'use es6';

import UIIcon from 'UIComponents/icon/UIIcon';
import { EDGE_TOOLBAR_ICON_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/_jsx(UIIcon, {
  name: "column",
  size: EDGE_TOOLBAR_ICON_SIZE
});